/**
 * Pastilles des signaux d'une station (lot 037) : `{ niveau, texte, court, nombre }`
 * pour `PageHeader.alertes`. Aucun montant n'y figure : le total des écarts de
 * caisse reste dans le détail serveur, masqué sans « montants visibles ».
 */

const numeros = (liste) => (liste || []).filter((valeur) => valeur !== null && valeur !== undefined);

const pistolets = (liste) => {
  const nombres = numeros(liste);
  if (nombres.length === 0) return '';
  return nombres.length === 1 ? `pistolet ${nombres[0]}` : `pistolets ${nombres.join(', ')}`;
};

const fois = (nombre) => `${nombre} fois`;

/** Pastille d'un signal, ou `null` si le code est inconnu. */
export const pastilleSignal = (signal, { action } = {}) => {
  if (!signal) return null;
  const niveau = signal.level === 'critique' ? 'critique' : 'attention';
  if (signal.code === 'NOZZLE_DRIFT') {
    const sens = signal.direction === 'OVER' ? 'en trop' : 'manquants';
    return {
      niveau,
      texte: `${signal.tank_name || 'Cuve'} : litres ${sens} ${fois(signal.days_exceeding)} en ${signal.window_days} jours (${pistolets(signal.nozzle_numbers) || 'pistolet à vérifier'})`,
      court: 'Dérive de pistolet',
      nombre: signal.days_exceeding,
    };
  }
  if (signal.code === 'ATTENDANT_CASH') {
    return {
      niveau,
      texte: `${signal.attendant_name || 'Pompiste'} : écart de caisse ${fois(signal.occurrences)} en ${signal.window_days} jours`,
      court: 'Écarts de caisse',
      nombre: signal.occurrences,
    };
  }
  if (signal.code === 'INDEX_REENTERED') {
    const lieux = pistolets(signal.nozzle_numbers);
    return {
      niveau,
      texte: `Index ressaisis à l’ouverture ${fois(signal.occurrences)} en ${signal.window_days} jours${lieux ? ` (${lieux})` : ''}`,
      court: 'Index ressaisis',
      nombre: signal.occurrences,
    };
  }
  if (signal.code === 'RECALIBRATION_READY') {
    return {
      niveau: 'info',
      texte: `Le barème de ${signal.tank_name || 'la cuve'} peut être recalibré`,
      court: 'Barème à recalibrer',
      action,
    };
  }
  return null;
};

/** Toutes les pastilles d'une réponse `insightsApi.station`, dans l'ordre reçu. */
export const pastillesSignaux = (vue, options = {}) =>
  ((vue && vue.signals) || []).map((signal) => pastilleSignal(signal, options)).filter(Boolean);
